import React, { Component } from "react"
import { NavDropdown } from "react-bootstrap"

export interface NavDropdownHoverProps {
  title: React.ReactNode
  id: string
  className?: string
  alignRight?: boolean
}

export interface NavDropdownHoverState {
  isOpen: boolean
}

export class NavDropdownHover extends Component<NavDropdownHoverProps, NavDropdownHoverState> {
  state: NavDropdownHoverState = {
    isOpen: false
  }

  handleOpen = () => this.setState({ isOpen: true })
  handleClose = () => this.setState({ isOpen: false })

  render() {
    return <NavDropdown title={this.props.title}
      alignRight={this.props.alignRight}
      onMouseEnter={this.handleOpen}
      onMouseLeave={this.handleClose}
      show={this.state.isOpen}
      id={this.props.id} className={this.props.className}>
      {this.props.children}
    </NavDropdown>
  }
}
